import type { ReactNode } from 'react';

import { Box } from '@mui/material';
import { Link } from 'react-router';

import { GrayLinkButton } from '@/components/Buttons/GrayLinkButton';
import Typography from '@/components/Typography';

export interface DataHubEmptyStateAction {
  label: string;
  to: string;
  icon: ReactNode;
  variant?: 'text' | 'outlined' | 'contained';
  onClick?: () => void;
}

export interface DataHubEmptyStateProps {
  title: string;
  description: ReactNode;
  actions?: DataHubEmptyStateAction[];
}

export const DataHubEmptyState = ({ title, description, actions }: DataHubEmptyStateProps) => {
  return (
    <Box
      sx={{
        py: '36px',
        px: 2,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        flex: 1
      }}
    >
      <Typography
        size={24}
        sx={{ fontWeight: 700 }}
      >
        {title}
      </Typography>
      <Typography>{description}</Typography>
      {actions?.map(action => (
        <GrayLinkButton
          key={action.to}
          component={Link}
          startIcon={action.icon}
          to={action.to}
          variant={action.variant}
          onClick={action.onClick}
        >
          {action.label}
        </GrayLinkButton>
      ))}
    </Box>
  );
};
